"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstContact = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var BuildColony_1 = require("../../../deferredActions/BuildColony");
var CardRenderer_1 = require("../../render/CardRenderer");
var FirstContact = (function (_super) {
    __extends(FirstContact, _super);
    function FirstContact() {
        return _super.call(this, {
            name: CardName_1.CardName.FIRST_CONTACT,
            tags: [Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'L401',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.colonies(1).br;
                    b.text('Place 1 colony.').br;
                    b.effect('When you trade, you pay 1 less resource for it.', function (eb) {
                        eb.trade().startEffect.tradeDiscount(1);
                    });
                }),
            },
        }) || this;
    }
    FirstContact.prototype.play = function (player) {
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build the colony'));
        player.colonyTradeDiscount++;
        return undefined;
    };
    FirstContact.prototype.onDiscard = function (player) {
        player.colonyTradeDiscount--;
    };
    return FirstContact;
}(PreludeCard_1.PreludeCard));
exports.FirstContact = FirstContact;
//# sourceMappingURL=FirstContact.js.map